import { HttpHeaders } from '@angular/common/http';

export const getHttpHeaders = (headers: Record<string, string>) => {
    return new HttpHeaders(headers);
};
